const jwt = require('jsonwebtoken')
const JWT_SECRET = 'wRtW6mbbR5XPVelLgrGUfsaAH4mXHsyv3cjdleGi'
const generateToken = (payload) => {
  return jwt.sign(payload, JWT_SECRET)
}
export { generateToken }